<template>
  <div id="app">
    <img v-if="$route.name !== '後臺'" src="./assets/basis/topLogo.svg" alt="" class="topLogo">
    <transition name="component-fadeUp" mode="out-in">
      <router-view :locationSrc="locaSrc"
      :footlogo="footLogo" @update:footlogo="val => footLogo = val"
      :result="testData" @update:result="val => updateVal(val)"></router-view>
    </transition>
    <div class="footLogo">
      <img src="./assets/basis/footLogo.svg" alt="" v-if="footLogo === false">
      <img src="./assets/basis/footLogo2.svg" alt="" v-if="footLogo">
      <br/>
      <template v-if="footLogo">
        <router-link to="/step1">
          <img src="./assets/basis/f-1.png" alt="">
        </router-link>
        <router-link to="/step2">
          <img src="./assets/basis/f-2.png" alt="">
        </router-link>
        <router-link to="/step3">
          <img src="./assets/basis/f-3.png" alt="">
        </router-link>
        <router-link to="/step4">
          <img src="./assets/basis/f-4.png" alt="">
        </router-link>
        <router-link to="/step0">
          <img src="./assets/basis/f-0.png" alt="">
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      testData: [],
      locaSrc: this.suite.locationHref,
      footLogo: false
    }
  },
  mounted: function () {
    // console.log(this.suite.locationHref)
    if (this.$route.fullPath !== '/') {
      this.footLogo = true
    }
    // console.log(this.$route)
  },
  methods: {
    updateVal: function ($val) {
      console.log('test', $val)
      Object.assign(this.testData, $val)
    }
  }
}
</script>

<style>
  @import url(./assets/main.css);
</style>



// WEBPACK FOOTER //
// src/App.vue